import { render, staticRenderFns } from "./404-body.vue?vue&type=template&id=723bedad&scoped=true"
import script from "./404-body.vue?vue&type=script&lang=js"
export * from "./404-body.vue?vue&type=script&lang=js"
import style0 from "./404-body.vue?vue&type=style&index=0&id=723bedad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723bedad",
  null
  
)

export default component.exports